import React from "react";

export default function NexlabsSummary() {
  return (
    <>
      <div className="py-2">
        <ul className="pl-6 app-list">
          <li>
            Reviewed code for a project to learn about code architecture,
            coding styles from senior developers.
          </li>
          <li>
            Collaborated with senior developers in debugging process and
            removing dead code.
          </li>
          <li>
            Developed a blog app <i>(with Nuxt.js and Laravel)</i> to put my
            learned skills into use.
          </li>
        </ul>
      </div>
    </>
  );
}
